<div class="progress mx-auto" [attr.data-value]="percentage">
  <span class="progress-left">
    <span class="progress-bar border-green"></span>
  </span>
  <span class="progress-right">
    <span class="progress-bar border-green"></span>
  </span>
  <div class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
    <div class="h2 font-weight-bold">{{percentage}}<sup class="small">%</sup></div>
  </div>
</div>
